;(function module() {
  angular.module('app.ui.form.ctrls').controller('AddAgGridFiltersController', [
    'filterOptions',
    'gridOptions',
    'logger',
    '$uibModalInstance',
    '$rootScope',
    'GridApi',
    function controller(
      filterOptions,
      gridOptions,
      logger,
      $uibModalInstance,
      $rootScope,
      GridApi
    ) {
      var vm = this
      vm.filterOptions = filterOptions
      vm.gridOptions = gridOptions
      vm.filterSwitch = {filter: false}

      vm.cancel = () => {
        $uibModalInstance.dismiss('cancel')
      }

      vm.saveFilter = filterName => {
        let filterOptionsSelected = false
        if (
          vm.filterOptions.saveFilter ||
          vm.filterOptions.saveColumnSetting ||
          vm.filterOptions.currentPositionInGrid ||
          vm.filterOptions.sorting
        )
          filterOptionsSelected = true
        if (!filterName) {
          logger.notify(
            'warning',
            'A Saved View name is required to save the filter'
          )
          return false
        }

        if (!filterOptionsSelected) {
          logger.notify('warning', 'Please select at least one filter options!')
          return false
        }

        vm.saveAgGridFilter(filterName)
      }

      vm.saveAgGridFilter = filterName => {
        let view = {
          filter: vm.filterOptions.saveFilter
            ? vm.gridOptions.api.getFilterModel()
            : undefined,
          columnState: vm.filterOptions.saveColumnSetting
            ? {
                state: vm.gridOptions.columnApi.getColumnState(),
                group: vm.gridOptions.columnApi.getColumnGroupState(),
              }
            : undefined,
          sort: vm.filterOptions.sorting
            ? vm.gridOptions.api.getSortModel()
            : undefined,
          index: vm.filterOptions.currentPositionInGrid
            ? Number(
                (vm.gridOptions.api.getFirstDisplayedRow() +
                  vm.gridOptions.api.getLastDisplayedRow()) /
                  2
              )
            : undefined,
        }

        const newFilter = {
          name: filterName,
          isPublic: Boolean(vm.filterSwitch.filter),
          userId: $rootScope.user.id,
          gridId: vm.filterOptions.gridName,
          filter: view,
        }

        const onSaveSuccess = successResponse => {
          Object.assign(newFilter, {
            id: successResponse.data.id,
          })
          logger.notify(
            'success',
            `New Saved View: '${newFilter.name}' created!`
          )
          $uibModalInstance.close(newFilter)
        }

        const onSaveFailure = failureResponse => {
          logger.notify(
            'error',
            `Save Current Views failed! <br/> Error Code: ${failureResponse.statusText}`
          )
        }

        if (newFilter.filter === '{}')
          logger.notify(
            'warning',
            `Select one or more filters from grid before saving!`
          )
        else {
          GridApi.createGridFilter(newFilter)
            .then(onSaveSuccess)
            .catch(onSaveFailure)
        }
      }
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/shared/directives/ag-grid-listing/ag-grid-filters/add-filters/add-filters.ctrl.js